<template>
  <v-app>
    <NavbarDesktop
      ref="deskNav"
      class="d-sm-flex d-md-flex"
      v-if="!isMobile"
    ></NavbarDesktop>
    <NavbarMobile
      ref="mobileNav"
      class="d-sm-flex d-md-flex"
      v-if="isMobile"
    ></NavbarMobile>

    <v-main id="main-page" style="">
      <v-navigation-drawer
        app
        clipped
        color="gray darken-4 black--text"
        min-width="400px"
        width="300px"
        v-if="showSidebar"
      >
        <SideNavbar></SideNavbar>
      </v-navigation-drawer>

      <v-container fluid>
        <v-container>
          <h1 class="page-title" v-if="pageTitle">{{ pageTitle }}</h1>
          <v-divider class="mt-0 mb-5" v-if="pageTitle"></v-divider>
          <slot name="page-content"></slot>
        </v-container>

        <h3
          id="sidebar-company-name align-right 
        "
          style="position:fixed;right:20;bo"
        >
          <v-spacer></v-spacer>
        </h3>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="scss">
.page-title {
  color: #cf1818;
  text-shadow: 1px 1px 1px #eee;
  font-size: 26px;
  font-weight: 300;
}
#main-page {
  color: #333;
  //background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABDgAAAIICAYAAACLul4YAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAinSURBVHhe7caxDQAwCAQxkv03/iJp2AEh2c1dAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAw06S1w8AAACw0u0CAAAALFX1AXhXA/QaH5vlAAAAAElFTkSuQmCC) !important;
  background-repeat: repeat;
  background-size: 230px 200px;
  background-color: #e0e0e0;
}
// .mainPage {
//   // height: 100vh;
//   display: block !important;
//   width: 100vw;
//   z-index: 999999 !important;
// }

// .custom-container {
//   flex-direction: unset !important;
// }
// .main-container {
//   z-index: 4000 !important;
//   display: block;
//   position: relative;
// }
// #particles-js {
//   width: 100%;
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   z-index: 0;
// }
</style>

<script>
import Vue from "vue";
import VueParticles from "vue-particles";
Vue.use(VueParticles);
import NavbarMobile from "../components/Partial/NavbarMobile";
import NavbarDesktop from "../components/Partial/NavbarDesktop";
import SideNavbar from "../components/Navbar/SideNavbar";

import SessionHelper from "../utils/SessionHelper";
export default {
  components: {
    NavbarMobile,
    NavbarDesktop,
    SideNavbar,
  },
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
    showNavBar: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      showNavBarD: false,
      resize: false,
      isMobile: false,
    };
  },
  mounted() {
    this.CheckLogin();
    window.addEventListener("resize", () => {
      this.checkIfIsMobile();
    });
    this.checkIfIsMobile();
    this.resize = !this.resize;
    this.showNavBarD = this.$props.showNavBar;
  },

  created() {
    window.addEventListener("resize", () => {
      this.resize = !this.resize;
      console.debug("resizing");

      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.showNavBarD = Boolean(false);
      } else if (this.$props.showNavBar) {
        this.showNavBarD = Boolean(true);
      }
    });
  },
  methods: {
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    CheckLogin() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        SessionHelper.Logoff(this.$route.params.companyAlias);
      } else {
        SessionHelper.loadUserInfo(this.$route.params.companyAlias);
        SessionHelper.loadCompanyInfo(this.$route.params.companyAlias);
      }
    },
    CurrentUserChanged(user) {
      this.$refs.mobileNav.CurrentUserChanged(user);
      this.$refs.deskNav.CurrentUserChanged(user);
    },
  },
  computed: {
    showSidebar() {
      return SessionHelper.checkPermission("SHOW_SIDEBAR");
    },
    companyInfo() {
      if (localStorage.companyInfo != null)
        return JSON.parse(localStorage.companyInfo);
      else return { ragioneSociale: "---" };
    },
    pageContentMarginTop() {
      let res = this.resize;
      res = !res;
      let height = 0;

      if (this.$refs.mobileNav != undefined) {
        height = this.$refs.mobileNav.$el.clientHeight + "px";
      } else height = 0;

      return height;
    },
  },
};
</script>
